module.exports = "<div class=\"view-photo\">\n  <img \n    src=\"{{ detail.url }}\" \n    alt=\"\" \n    id=\"photos\"\n  />\n</div>"